import * as Sentry from '@sentry/react';
import type { Extras } from '@sentry/types';
import { Team } from 'routes/merchant-scoped-portal/teamRegistry';

export const logReferralError = (error: Error, extraData?: Extras) => {
  Sentry.withScope((scope) => {
    scope.setTag('route', 'refer');
    scope.setTag('feature', 'referrals');
    scope.setTag('team', Team.ActivationWeb);
    if (extraData) {
      scope.setExtras(extraData);
    }
    Sentry.captureException(error);
  });
};
